import { TFunction } from 'i18next';
import { APP_URLS } from 'constants/urls';

type Args = {
  id: string;
  isUsersManagementLocked: boolean;
  sitesCount: number;
  t: TFunction<'translation', undefined>;
  usersCount: number;
};

export default function getTableTabs({
  id,
  sitesCount,
  t,
  usersCount,
  isUsersManagementLocked,
}: Args) {
  const tabs = [
    {
      label: t('sector-details'),
      value: APP_URLS.dashboard.sectors.view.getDynamicPath({
        pathParts: { id },
      }),
    },
    {
      label: t('linked-sites'),
      value: APP_URLS.dashboard.sectors.sites.getDynamicPath({
        pathParts: { id },
      }),
      counter: sitesCount,
    },
  ];
  if (!isUsersManagementLocked) {
    tabs.push({
      label: t('members'),
      value: APP_URLS.dashboard.sectors.users.getDynamicPath({
        pathParts: { id },
      }),
      counter: usersCount,
    });
  }
  return tabs;
}
